export const ENTITY_TAG_PICKER_SEARCH_ENTITY_TAGS = "ENTITY_TAG_PICKER_SEARCH_ENTITY_TAGS";
export const ENTITY_TAG_PICKER_SEARCH_ENTITY_TAGS_RESPONSE = "ENTITY_TAG_PICKER_SEARCH_ENTITY_TAGS_RESPONSE";